import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=b5d92c6a"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"
import style0 from "./Option.vue?vue&type=style&index=0&id=b5d92c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports